// userStatusService.js
import { computed } from 'vue';

// This function takes the `user` ref and returns computed values
export function useUserStatus(user) {
    
  const isBankProvided = computed(() => {
    // Check if user and user.bank are defined before accessing user.bank.name
    return user.value && user.value.bank && user.value.bank.name ? true : false;
  });

  const isAddressProvided = computed(() => {
    // Check if user and user.bank are defined before accessing user.bank.name
    return user.value && user.value.bank && user.value.address.street ? true : false;
  });
  
  const isVatProvided = computed(() => user.value && user.value.vat !== '');
  
  const showAlert = computed(() => {
    return user.value && (!isVatProvided.value || !isBankProvided.value) && user.value.status === 'approved';
  });

  // Return the computed properties
  return {
    isBankProvided,
    isAddressProvided,
    isVatProvided,
    showAlert
  };
}